// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__OSkPF","requiredAsterisk":"Info_requiredAsterisk__2D2E-"};